import { useEffect, useMemo, useState } from "react";
import type { ILanguage } from "../../../interfaces";
import {
  buildLanguageFlagUrl,
  resolveLanguageCountryCode,
  resolveLanguageInitials,
} from "./networkingMapLanguageFlags";

type NetworkingMapLanguageIconProps = {
  language: string;
  catalog: ILanguage[];
};

export default function NetworkingMapLanguageIcon({
  language,
  catalog,
}: NetworkingMapLanguageIconProps) {
  const countryCode = useMemo(
    () => resolveLanguageCountryCode(language, catalog),
    [language, catalog],
  );
  const initials = useMemo(
    () => resolveLanguageInitials(language, catalog),
    [language, catalog],
  );
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [language, countryCode]);

  const showFlag = Boolean(countryCode && !imageFailed);

  return (
    <span
      className="flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white"
      aria-hidden
    >
      {showFlag && countryCode ? (
        <img
          src={buildLanguageFlagUrl(countryCode, 40)}
          srcSet={`${buildLanguageFlagUrl(countryCode, 80)} 2x`}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="font-['Roboto'] text-[10px] font-semibold uppercase leading-none text-gray-font">
          {initials}
        </span>
      )}
    </span>
  );
}
